import { LANGUAGES as DEFAULT_LANGUAGES } from 'constants/languageConstants';
import { SOURCE_LANGUAGE_CODE } from 'constants/languageHelpers';

export const normalizeLanguageValue = (language) => {
  if (typeof language === 'string') {
    return language;
  }

  if (language?.value) {
    return language.value;
  }

  if (language?.language) {
    return language.language;
  }

  if (language?.languageCode) {
    return language.languageCode;
  }

  return null;
};

export const updateLanguagesHelper = (languageList = [], defaultLanguages = [], setLanguages) => {
  const normalizedValues = languageList
    .map(normalizeLanguageValue)
    .filter(Boolean)
    .map((v) => v?.toLowerCase() || v);

  if (!defaultLanguages.length) {
    return [];
  }

  // Always get the source language from default languages (case-insensitive)
  const sourceLanguage = defaultLanguages.find(
    (lang) => lang.value?.toLowerCase() === SOURCE_LANGUAGE_CODE?.toLowerCase()
  ) || defaultLanguages[0];
  
  // Filter default languages to only include those that match fetched languages (case-insensitive)
  const fetchedLanguages = defaultLanguages.filter((lang) =>
    normalizedValues.includes(lang.value?.toLowerCase())
  );

  // Always include source language, then add fetched languages (avoiding duplicates)
  const languageMap = new Map();
  
  // First, add source language (always shown)
  languageMap.set(sourceLanguage.value, sourceLanguage);
  
  // Then, add all fetched languages (saved languages from CourseLanguagesPage)
  fetchedLanguages.forEach((lang) => {
    languageMap.set(lang.value, lang);
  });

  const nextLanguages = Array.from(languageMap.values());
  setLanguages?.(nextLanguages);
  return nextLanguages;
};

export let LANGUAGES = DEFAULT_LANGUAGES;

const setLanguages = (languageList) => {
  LANGUAGES = languageList;
};

export const updateLanguages = (languageList = []) =>
  updateLanguagesHelper(languageList, DEFAULT_LANGUAGES, setLanguages);

